/* eslint-disable react/no-array-index-key */
import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import ExtraChargesActions from '@Actions/configurations/extraChargesAction';

import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

const SelectExtraCharge = ({
  user, onChange, selectedChargeName, disabled, showError, title, getChargesLoading, customStyle, getPopupContainer, open, errorOutline, containerClassName, notRequired, extraChargesResults, getCharges,
  excludeCharges, entityName,
}) => {
  const [isUserReady, setIsUserReady] = useState(false);

  useEffect(() => {
    if (!isUserReady) {
      getCharges('',entityName);
      setIsUserReady(true);
    }
  }, []);

  return (
    <div className={containerClassName}>
      {title
        ? (
          <label className="orgFormLabel">
            {title}
            {notRequired ? '' : <span style={{ color: 'red' }}>{'  *'}</span>}
          </label>
        )
        : <label />}
      <PRZSelect
        getPopupContainer={getPopupContainer}
        value={!getChargesLoading && (selectedChargeName || '')}
        open={open}
        filterOption={false}
        disabled={disabled || getChargesLoading}
        onChange={(value) => onChange(extraChargesResults.filter((item) => item?.ledger_name === value)[0])}
        style={{
          border: errorOutline ? '1px solid red' : '1px solid rgba(68, 130, 218, 0.2)',
          borderRadius: '2px',
          height: '28px',
          width: '100%',
          fontSize: '13px',
          ...customStyle,
        }}
        allowClear
      >
        {extraChargesResults?.filter((item) => (!excludeCharges.includes(item?.ledger_name) && !(item?.ledger_name === 'Freight Charge' && item?.is_system_charge)))?.map((item) => (
          <Option key={item?.ledger_id} value={item?.ledger_name}>
            {`${item?.ledger_name}`}
          </Option>
        ))}
      </PRZSelect>
      {showError && (
        <div className="input-error">
          *Please select charge
        </div>
      )}
    </div>

  );
};

const mapStateToProps = ({ UserReducers, TdsTcsReducers, ExtraChargesReducers }) => ({
  user: UserReducers.user,
  extraChargesResults: ExtraChargesReducers.extraChargesResults,
  getChargesLoading: ExtraChargesReducers.getChargeLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCharges: (orgId, entityName) => dispatch(ExtraChargesActions.getCharges(orgId, entityName)),


});

SelectExtraCharge.propTypes = {
  user: PropTypes.any,
  tdsTcs: PropTypes.any,
  selectedTaxType: PropTypes.any,
  getTdsTcs: PropTypes.func,
  getTdsTcsLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  taxTypeName: PropTypes.any,
  title: PropTypes.any,
  customStyle: PropTypes.any,
  errorOutline: PropTypes.any,
  getPopupContainer: PropTypes.any,
  open: PropTypes.any,
  containerClassName: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectExtraCharge));
